import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const adminGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.userData) {
    await authService.waitForAuthReady();
  }

  if (authService.isAdmin()) {
    return true;
  }

  console.warn('Admin access denied for route:', state.url);
  return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
};
